@if (isVisible) {
<div class="company-suspension-warning-text select-none">
  <button type="button" class="company-suspension-warning-dismiss" (click)="dismiss()" aria-label="Dismiss">×</button>
  <div>Your company is suspended from working with us.</div>
  <div class="company-suspension-warning-subtext">Please contact a 5F representative to reactivate your account.</div>
</div>
}
